var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNmDoughnut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-doughnut-nm-cls-1 {\n        fill: #333;\n      }\n\n      .dummy-widget-doughnut-nm-cls-1, .dummy-widget-doughnut-nm-cls-2, .dummy-widget-doughnut-nm-cls-3, .dummy-widget-doughnut-nm-cls-4, .dummy-widget-doughnut-nm-cls-5, .dummy-widget-doughnut-nm-cls-6, .dummy-widget-doughnut-nm-cls-7, .dummy-widget-doughnut-nm-cls-8 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-doughnut-nm-cls-9 {\n        clip-path: url(#dummy-widget-doughnut-nm-clippath);\n      }\n\n      .dummy-widget-doughnut-nm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-doughnut-nm-cls-3 {\n        fill: #4eb062;\n      }\n\n      .dummy-widget-doughnut-nm-cls-10 {\n        clip-path: url(#dummy-widget-doughnut-nm-clippath-1);\n      }\n\n      .dummy-widget-doughnut-nm-cls-4 {\n        fill: #f29c3f;\n      }\n\n      .dummy-widget-doughnut-nm-cls-5 {\n        fill: #202020;\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .dummy-widget-doughnut-nm-cls-6 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-doughnut-nm-cls-7 {\n        fill: #49beed;\n      }\n\n      .dummy-widget-doughnut-nm-cls-8 {\n        fill: #3463ac;\n      }\n\n      .dummy-widget-doughnut-nm-cls-11 {\n        fill: #1e1e1e;\n        stroke: #2b2b2b;\n        stroke-miterlimit: 10;\n        stroke-width: .4px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-doughnut-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-nm-cls-2",
    x: 7.4,
    y: 7.5,
    width: 155.2,
    height: 155.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-doughnut-nm-clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-2",
    d: "M85.4,52.6l-33.1,6.9c3.2,15.4,16.8,27,33.1,27s18-4.4,23.6-9.6l-23.6-24.4h0Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-nm-cls-6",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-doughnut-nm-cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-nm-cls-5",
    x: -72.2,
    y: 7.5,
    width: 98.3,
    height: 155.3,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-11",
    d: "M44.7,7.8h81.2c3.4,0,6.1,2.7,6.1,6.1v142.9c0,3.4-2.7,6.1-6.1,6.1H44.7c-3.4,0-6.1-2.7-6.1-6.1V13.9c0-3.4,2.7-6.1,6.1-6.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-nm-cls-4",
    cx: 54.7,
    cy: 117.3,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-nm-cls-3",
    cx: 54.7,
    cy: 137.3,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-nm-cls-7",
    cx: 54.7,
    cy: 127.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-nm-cls-8",
    cx: 54.7,
    cy: 147.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M61.6,115.1h34.3c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-34.3c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M108.2,115.1h.6c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-.6c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M113.7,115.1h3.9c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-3.9c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M108.2,125.2h.6c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-.6c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M113.7,125.2h3.9c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-3.9c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M108.2,135.1h.6c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-.6c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-nm-cls-1",
    x: 111.8,
    y: 135.1,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M108.2,145.1h.6c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-.6c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M113.7,145.1h3.9c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-3.9c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M61.6,125.2h25.2c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-25.2c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M61.6,135.1h31.7c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-31.7c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-1",
    d: "M61.6,145.1h34.3c1,0,1.9.9,1.9,1.9v.6c0,1-.8,1.9-1.9,1.9h-34.3c-1,0-1.9-.9-1.9-1.9v-.6c0-1,.8-1.9,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-7",
    d: "M85.4,18.8c-18.7,0-33.8,15.2-33.8,33.9s15.1,33.8,33.8,33.8,33.8-15.2,33.8-33.8-15.1-33.9-33.8-33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-3",
    d: "M96.3,20.6l-10.9,32.1,32.7,8.9c.8-2.8,1.2-5.8,1.2-8.9,0-14.9-9.6-27.5-23-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-8",
    d: "M85.4,52.6l23.6,24.3c4.3-4.2,7.5-9.5,9.1-15.4,0,0-32.7-8.9-32.7-8.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-doughnut-nm-cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-4",
    d: "M85.4,18.8c-18.7,0-33.8,15.2-33.8,33.9s15.1,33.8,33.8,33.8,33.8-15.2,33.8-33.8-15.1-33.9-33.8-33.9Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-nm-cls-11",
    cx: 85.4,
    cy: 52.7,
    r: 23.4
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-nm-cls-5",
    x: 145.1,
    y: 7.5,
    width: 98.3,
    height: 72.3,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-nm-cls-5",
    d: "M151.2,89.8h86.1c3.4,0,6.1,2.8,6.1,6.2v60.7c0,3.4-2.7,6.2-6.1,6.2h-86.1c-3.4,0-6.1-2.8-6.1-6.2v-60.7c0-3.4,2.7-6.2,6.1-6.2h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmDoughnut);
export default __webpack_public_path__ + "static/media/nm_doughnut.d07caf54.svg";
export { ForwardRef as ReactComponent };